import { render, staticRenderFns } from "./emailInput.vue?vue&type=template&id=10cf6456&scoped=true"
import script from "./emailInput.vue?vue&type=script&lang=js"
export * from "./emailInput.vue?vue&type=script&lang=js"
import style0 from "./emailInput.vue?vue&type=style&index=0&id=10cf6456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cf6456",
  null
  
)

export default component.exports